// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



import DropDown from 'components/DropDown'
import TagColorSelector from 'components/TagColorSelector'

import PropTypes from 'prop-types'

import 'styles/components/settings/tags/TagDropDownList.styl'

const TagColorSelectorDropdown = React.createClass({

  propTypes: {
    colorClicked: PropTypes.func.isRequired,
    onClickOutside: PropTypes.func.isRequired
  },

  onColorClick(tagColor) {
    return this.props.colorClicked(tagColor)
  },

  render() {
    return (
      <DropDown
        className="TagColorSelectDropdown tag-color-select-dropdown"
        onClickOutside={this.props.onClickOutside}>
        <div className="title">
          Pick Tag Color
        </div>
        <TagColorSelector {...this.props} />
      </DropDown>
    )
  }
})

export default TagColorSelectorDropdown



// WEBPACK FOOTER //
// ./src/scripts/components/settings/tags/TagColorSelectorDropdown.js